<div class="flex bg-gray-100 rounded-lg p-1">
    <button
        *ngFor="let option of options"
        class="px-1.5 md:px-3 py-2 rounded-lg text-xs md:text-sm font-semibold transition-colors duration-200 whitespace-nowrap"
        [ngClass]="{
            'bg-white shadow text-gray-900': selected === option.value,
            'text-gray-500 hover:text-gray-900': selected !== option.value,
        }"
        (click)="select(option.value)"
    >
        {{ option.label }}
    </button>
</div>
